export default "__VITE_ASSET__D69ErMHo__"